import { NgModule } from '@angular/core';

import { AdsBannerComponent } from './ads-banner/ads-banner';
import { EmptyStateComponent } from './empty-state/empty-state';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [
    AdsBannerComponent,
    EmptyStateComponent
  ],
	imports: [
    CommonModule,
  ],
	exports: [
    AdsBannerComponent,
    EmptyStateComponent
  ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts